import {
  CONSTANT,
  hasQuebecServiceAddress,
  hBBQualificationFields
} from '../../utils/constant';
import { getFieldValue } from '../utils';

const {
  KEYS: { CHANNELS}
} = CONSTANT;

const isChannelValidForPhoneRemoval = (channelName) => [
  CHANNELS.SBS_TELESALES_TI,
  CHANNELS.SMB_TI_Sales_Base_Management,
  CHANNELS.SMB_TI_Sales_Digital
].includes(channelName);

const isChannelOptikTvCompatible = (channelName) => [
  'SMB Growth Sales W 2A',
  'SMB Growth Sales W 2B',
  'SMB Growth Sales W 2C',
  'SMB Growth Sales W 2D',
  'SMB Growth Sales W 1A',
  'SMB Growth Sales W 1B',
  'SMB Growth Sales W 1C',
  'SMB Growth Sales W 1D',
  'SMB Growth Sales 30 to 100 2A',
  'SMB Growth Sales 30 to 100 2B',
  'SMB Growth Sales 30 to 100 2C',
  'SMB Retention Sales 30 to 100 2D',
  'SMB Growth Sales Advance WEST',
  'SMB New Growth Market 1',
  'SMB New Growth Market 2',
  'White Glove NBD Technicians',
  'SMB TI Sales Digital',
  'SMB TI Sales Base Management',
  'SMB TI ADT Retention',
  'SMB TI Digital - EN',
  'SMB TI Digital - FR',
  'SMB TI HSIA Growth',
  'SMB TI NBS Value Add',
  'SMB TI WLN Retention',
  'SMB TI WLS Growth QC',
  'SMB TI WLS Growth ROC',
  'SBS Telesales TI',
  'SMB L&R 2',
  'SMB L&R 3',
  'SMB L&R 4',
  'SMB L&R 5',
  'SMB L&R TI',
  'SMB L&R TI 2',
  'SMB L&R TI 3',
  'SMB RFS 1',
  'SMB RFS 2'
].includes(channelName);

const isChannelOptikTvCompatibleABAndBC = (channelName) => [
  'DEALER'
].includes(channelName);

const isChannelVulcanCompatible = (channelName) => [
  'TM Test Ind Dlr',
  'CORP_STORE'
].includes(channelName);

const isOutletIDValid = (outlet) => [
  '0000029594',
  '0000029610',
  '0000029654',
  '0000423002',
  '0000426001',
  '0000602001',
  '0000602003',
  '0000602007',
  '0000602008',
  '0000602010',
  '0000606002',
  '0000614007',
  '0000625002',
  '0000625004',
  '0000625005',
  '0000625008',
  '0000633005',
  '0000692003',
  '0000693006',
  '1100000008',
  '1100000541',
  '1100000629',
  '1100025680',
  '1100025681',
  '1100026300',
  '1100032061',
  '1100034223',
  '1100034406',
  '1100037897',
  '1100040659',
  '1100040861',
  '1100041423',
  '1100043777',
  '1100046099',
  '1100047437',
  '1100047705',
  '1100048577',
  '1100048613',
  '1100048749',
  '1100048751',
  '1100048752',
  '1100048753',
  '1100048773',
  '1100049115',
  '1100049641',
  '1100049696',
  '1100049698',
  '1100050486',
  '1100050554',
  '1100050555',
  '1100050840',
  '1100052292',
  '1100053681',
  '1100053710',
  '1100053711',
  '1100053712',
  '1100053735',
  '1100053736',
  '1100053737',
  '1100053738',
  '1100053739',
  'B001000001',
  'B00AB00431',
  'B00AB00478',
  'B00AB00479',
  'B00AB00482',
  'B00AB00500',
  'B00AB00615',
  'B00AB00834',
  'B00AB00970'
].includes(outlet);

const is7XChannel = (channelName) => channelName === CHANNELS['7X'];

const isNGM = (channelName) => channelName === CHANNELS.NGM;

const isSbsTelesalesTiChannel = (channelName) => channelName === CHANNELS.SBS_TELESALES_TI;

const isChannelSMBDigitalFr = (channelName) => channelName === CHANNELS['SMB TI Digital - FR'];

const isSMBGrowthSalesCBS = (channelName) => channelName === CHANNELS['SMB Growth Sales CBS'];

const hasQuebecInAddress = (address = '') => {
  return (
    address.includes(hasQuebecServiceAddress[0]) ||
    address.includes(hasQuebecServiceAddress[1]) ||
    address.includes(hasQuebecServiceAddress[2])
  );
};

const getHBBQualificationAnswers = (formFields) => {
  const hBBQualificationValues = [];
  hBBQualificationFields.forEach(key => {
    hBBQualificationValues.push(getFieldValue(key, formFields));
  });
  return hBBQualificationValues;
};

export {
  isChannelValidForPhoneRemoval,
  isChannelOptikTvCompatible,
  isChannelOptikTvCompatibleABAndBC,
  isChannelVulcanCompatible,
  isOutletIDValid,
  is7XChannel,
  isNGM,
  isSbsTelesalesTiChannel,
  isChannelSMBDigitalFr,
  isSMBGrowthSalesCBS,
  hasQuebecInAddress,
  getHBBQualificationAnswers
};